import { CaregiverDto, Config } from '@ecdlink/core';
import { CaregiverInput } from '@ecdlink/graphql';
import { api } from '../axios.helper';

class CaregiverService {
  _accessToken: string;

  constructor(accessToken: string) {
    this._accessToken = accessToken;
  }

  async getCaregivers(): Promise<CaregiverDto[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'GetAllCaregiver',
    });

    if (response.status !== 200) {
      throw new Error('Getting Caregivers failed - Server connection error');
    }

    return response.data.data.allCaregiver;
  }

  async getCaregiverById(careGiverId: string): Promise<CaregiverDto> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);

    const response = await apiInstance.post<any>(``, {
      id: 'GetCaregiverById',
      variables: {
        careGiverId: careGiverId,
      },
    });

    if (response.status !== 200) {
      throw new Error('Getting caregiver failed - Server connection error');
    }

    return response.data.data.getCaregiverById;
  }

  async updateCareGiver(
    id: string,
    input: CaregiverInput
  ): Promise<CaregiverDto> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'updateCaregiver',
      variables: {
        id: id,
        input: input,
      },
    });

    if (response.status !== 200) {
      throw new Error('Updating caregiver failed - Server connection error');
    }

    return response.data.data.updateCaregiver;
  }

  async createCaregiver(input: CaregiverInput): Promise<CaregiverDto> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'createCaregiver',
      variables: {
        input: input,
      },
    });

    if (response.status !== 200) {
      throw new Error('Creating caregiver failed - Server connection error');
    }

    return response.data.data.createCaregiver;
  }

  async upsertCaregiver(input: CaregiverInput): Promise<CaregiverDto> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'upsertCaregiver',
      variables: {
        input: input,
      },
    });

    if (response.status !== 200) {
      throw new Error('Upsert caregiver failed - Server connection error');
    }

    return response.data.data.upsertCaregiver;
  }

  async updateCareGiverGrants(
    childUserId: string,
    grantIds: string[]
  ): Promise<CaregiverDto> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: `updateCareGiverGrants`,
      variables: {
        childUserId: childUserId,
        grantIds: grantIds,
      },
    });

    if (response.status !== 200) {
      throw new Error(
        'Updating caregiver grants failed - Server connection error'
      );
    }

    return response.data.data.updateCareGiverGrants;
  }
}

export default CaregiverService;
